/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterRingSize_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuRingSize_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterRingSize_itemSearch";
};
export type SbSharedRefineMenuFilterRingSize_itemSearch$data = SbSharedRefineMenuFilterRingSize_itemSearch;
export type SbSharedRefineMenuFilterRingSize_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterRingSize_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterRingSize_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterRingSize_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRingSize_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'ddd880ebaee3accaf11695f2aab00784';
export default node;
